export default __webpack_public_path__ + "static/930-4124ed89909d8feaea2106c14de307ed.gif";